import { Injectable, inject } from '@angular/core';
import {LorenFormFieldError} from '../../../loren-entity-form-card/interfaces/loren-form-field-error.interface';
import {TranslocoService} from '@jsverse/transloco';
import {first} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LorenFormErrorsDecoratorService {
    private translateService = inject(TranslocoService);


    private static readonly ERRORS_FIELD_MINLENGTH = 'errors.field_minlength';
    private static readonly ERRORS_FIELD_REQUIRED = 'errors.field_required';
    private static readonly ERRORS_FIELD_PATTERN = 'errors.field_pattern';

    decorateErrors(errors: LorenFormFieldError[]) {
        const labels = errors.map(x => x.label);
        labels.push(...[
            LorenFormErrorsDecoratorService.ERRORS_FIELD_MINLENGTH,
            LorenFormErrorsDecoratorService.ERRORS_FIELD_REQUIRED,
            LorenFormErrorsDecoratorService.ERRORS_FIELD_PATTERN]);

        this.translateService.selectTranslate(labels)
            .pipe(first())
            .subscribe(translations => {
                errors.forEach(err => {
                    switch (err.errKey) {
                        case 'minlength': {
                            let message = translations[LorenFormErrorsDecoratorService.ERRORS_FIELD_MINLENGTH];
                                const regex = new RegExp(`{{\\s*value\\s*}}`);
                                message = message.replace(regex, err.errVal.requiredLength);

                            err.errMsg = message;
                            break;
                        }
                        case 'required': {
                            err.errMsg = translations[LorenFormErrorsDecoratorService.ERRORS_FIELD_REQUIRED];
                            break;
                        }
                        case 'pattern': {
                            err.errMsg = translations[LorenFormErrorsDecoratorService.ERRORS_FIELD_PATTERN];
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                });
            });
    }
}
